import React from "react";
import { Link } from "react-router-dom";
import styles from "../InverluxApps.module.css";

const Support = () => (
  <section className={styles.pageSection}>
    <div className={styles.narrowWidth}>
      <p className={styles.eyebrow}>Inverlux Apps support</p>
      <h1>How can we help?</h1>
      <p className={styles.pageIntro}>
        For help with Collapse All for Gmail, email Inverlux LLC at the address
        below. There is no support form or account required.
      </p>

      <div className={styles.supportCard}>
        <p className={styles.supportLabel}>Public support email</p>
        <a href="mailto:support@inverlux.com">support@inverlux.com</a>
        <p>
          When reporting an issue, include your Chrome version, a short
          description of what happened, and the steps that reproduce it. Please
          do not send sensitive email content.
        </p>
      </div>

      <div className={styles.inlineLinks}>
        <Link to="/gmail-collapse-all">Collapse All for Gmail</Link>
        <Link to="/gmail-collapse-all/privacy">Privacy Policy</Link>
      </div>
    </div>
  </section>
);

export default Support;
